import * as React from 'react';
import { SignInEmailPassword } from '../auth/sign-in/email-password/';
import { handleActions } from 'redux-actions'; // TODO refactor this and move the reducers into their own file
import { connect } from 'react-redux';
import Dashboard from '../dashboard';

export enum ACTION_TYPES {
  ONBOARDING_COMPLETE = '@DONACO/ONBOARDING_COMPLETE'
}

const defaultState = {
  onboardingComplete: false,
  stripeConnected: false
};

export const homeReducer = handleActions(
  {
    [ACTION_TYPES.ONBOARDING_COMPLETE]: (state, action) => {
      return {
        ...state,
        onboardingComplete: true
      };
    }
  },
  defaultState
);

class Home extends React.Component {
  render() {
    const { auth } = this.props;

    const isSignedIn: boolean = auth.status === 'SIGNED_IN';

    return (
      <div>
        {!isSignedIn && (
          <div>
            <SignInEmailPassword
              loginFail={false}
            />
          </div>
        )}
        {isSignedIn && <Dashboard />
        }
      </div>
    );
  }
}

const mapDispatchToProps = () => {
  return {};
};

const mapStateToProps = ({ auth, home }) => {
  return { auth, home };
};

export const HomeComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
